<template>
  <div>
    <b-card
      class="p-md-3"
    >
      <template #header>
        <div>
          <h3><strong>Contact Sales</strong></h3>
        </div>
      </template>
      <validation-observer #default="{handleSubmit}">
        <b-form @submit.prevent>
          <contact-sales-inputs :contact="contact" />
          <b-row>
            <b-col>
              <b-button
                variant="outline-primary"
                class="btn-pill"
                @click="$router.back()"
              >
                Discard
              </b-button>
            </b-col>
            <b-col class="text-right">
              <submit-button v-bind="{submit,handleSubmit,submitText:'Contact us'}" />
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import SubmitButton from '@/components/FormInputs/SubmitButton.vue'
import ContactSalesInputs from './ContactSalesInputs.vue'

export default {
  name: 'ContactSalesForm',
  components: { ContactSalesInputs, SubmitButton },
  props: {
    contact: { type: Object, default: () => {} },
    submit: { type: Function, default: () => {} },
  },
}
</script>

<style>

</style>
